/** 会员中心 **/
export const NEWEST_TENDER_URL =
  process.env.VUE_APP_OLD_SEARCH_URL + "/openTender.html#?tabindex=1";
export const NEWEST_WINNING_URL =
  process.env.VUE_APP_OLD_SEARCH_URL + "/openTender.html#?tabindex=2";
export const WILL_BUILD_PROJECT_URL =
  process.env.VUE_APP_OLD_SEARCH_URL + "/constrProject.html";
export const APPROVAL_PROJECT_URL =
  process.env.VUE_APP_OLD_SEARCH_URL + "/spxmProject.html";
export const EXCELLENT_SUPPLIER_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/ExcellentSupplierDetail.html";
